export default __webpack_public_path__ + "static/media/lacessories12.978d9c2b.jpeg";